import { render } from "./PageMain.vue?vue&type=template&id=9f7d7814"
import script from "./PageMain.vue?vue&type=script&lang=js"
export * from "./PageMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__